import type { RootState } from '@src/store/reduxstore';
import type { Selector } from '@types';

export const getUrlData = (url: string) => (state: RootState) => {
  const { items } = state.urlPreview;
  return items[url] || { url, title: '', description: '', urlImage: '' };
};

export const urlAlreadyExist = (url: string) => (state: RootState) => {
  const { items } = state.urlPreview;
  return (
    items[url]?.title || items[url]?.urlImage || items[url]?.description || null
  );
};

export const getUrlLoading: Selector<boolean> = state =>
  state.urlPreview.loading.includes('fetch-url');

export const getShowUrlPreview: Selector<boolean> = state =>
  state.urlPreview.showUrlPreview;
